<inspierty-header></inspierty-header>

<main class="m-8">
  <router-outlet></router-outlet>
</main>

<inspierty-footer></inspierty-footer>
